<script setup>
import StatCard from "@/components/global-themed/StatCard.vue";
import BaseCard from "@/components/global-themed/BaseCard.vue";
import {usePyCrawlFormatters} from "@/composables/admin/usePyCrawlAnalytics";

defineProps({
    queue: {type: Object, required: true},
});

const {formatCount} = usePyCrawlFormatters();
</script>

<template>
  <BaseCard>
    <h2 class="tw-text-xl tw-font-semibold tw-text-font-primary tw-mb-4">
      Queue State
    </h2>
    <div class="tw-grid tw-grid-cols-3 tw-gap-3">
      <StatCard variant="tight">
        <template #stat>
          {{ formatCount(queue.queued) }}
        </template>
        <template #title>
          Queued Jobs
        </template>
      </StatCard>
      <StatCard variant="tight">
        <template #stat>
          {{ formatCount(queue.running) }}
        </template>
        <template #title>
          Running Jobs
        </template>
      </StatCard>
      <StatCard variant="tight">
        <template #stat>
          {{ formatCount(queue.active_domains) }}
        </template>
        <template #title>
          Active Domains
        </template>
      </StatCard>
    </div>
  </BaseCard>
</template>
